// extracted by mini-css-extract-plugin
module.exports = {"qrCode":"qrCode-3DQme7mw","closeBtn":"closeBtn-3-lRaInS"};